export default "__VITE_ASSET__C50173wB__"